import Alert, { AlertCategoryEnum } from "../misc/components/Alert";
import Modal from "../misc/components/modal";
import * as React from "react";

export const ImportSettingModal = ({ onClose, onSave }) => {
    const [settings, setSettings] = React.useState<string>();
    const [loading, setLoading] = React.useState<boolean>(false);
    const [error, setError] = React.useState<string>();
    const reader = new FileReader();

    const onFileChange = (selectedFile) => {
        setError(undefined);
        setLoading(true);
        reader.readAsText(selectedFile)
    }

    reader.onload = (event) => {
        setSettings(event.target.result as string);
        setLoading(false);
    };

    const onSaveClick = async () => {
        try {
            onSave(JSON.parse(settings))
            setError(undefined);
            onClose();
            
        } catch (error) {
            setError("Invalid JSON File.")
        }
    }

    return (
        <Modal show={true} header="Import Study Settings">
             {error ? <Alert show={true} category={AlertCategoryEnum.Danger}>{error}</Alert> : null}
            <div className="row">
                <div className="col-md-12">
                    <div className="panel-body">
                        <div className="form-group">
                            <input type="file" className="form-control" accept=".json" onChange={(e) => onFileChange(e.target.files[0])} />
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal-footer">
                <button className="btn btn-primary" type="submit" disabled={loading || error != undefined} onClick={onSaveClick}>
                    Import
                </button> &nbsp;
                <button className="btn btn-primary btn-outline" disabled={loading} onClick={onClose}>
                    Close
                </button>
            </div>
        </Modal>
    );
}